module.exports = __webpack_public_path__ + "media/images/news-2-33570d63c68111a917211468bb4df21f.jpg";